










import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'text-area',
    props: {
        value: String,
        placeholder: String
    },
    data() {
        return {
            style: style
        }
    },
    computed: {
        model: {
            get(): string {
                return this.value
            },
            set(value: string): void {
                this.$emit('input', value);
            }
        }
    }
})
